import { render, staticRenderFns } from "./prepareMain.vue?vue&type=template&id=1879a118&scoped=true"
import script from "./prepareMain.vue?vue&type=script&lang=js"
export * from "./prepareMain.vue?vue&type=script&lang=js"
import style0 from "./prepareMain.vue?vue&type=style&index=0&id=1879a118&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1879a118",
  null
  
)

export default component.exports